import css from "./Loading.module.css"
import {useEffect, useState} from "react";

const Loading = ({title, text}) => {
    const [isShown, setShown] = useState(0)

    useEffect(() => {
        setTimeout(() => {
            setShown(1)
        }, 10)
    })

    return (
        <div className={css.loaderOverlay} style={{opacity: isShown}}>
            <div className={css.loader}>
                <div className={css.spinner}>
                    <div className={css.spinnerRing}></div>
                    <div className={css.spinnerIcon}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                             stroke-linecap="round" stroke-linejoin="round">
                            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                        </svg>
                    </div>
                </div>
                <div className={css.loaderText}>
                    <h2>{title}<span className={css.dots}><span>.</span><span>.</span><span>.</span></span></h2>
                    <p>{text}</p>
                </div>
                <div className={css.loaderProgress}>
                    <div className={css.loaderProgressBar}></div>
                </div>
            </div>
        </div>
    );
};

export default Loading;